import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { I18nProvider } from '@/lib/i18n';
import { BrandingProvider } from '@/lib/branding';
import { AuthProvider } from '@/lib/auth';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AppShell, FullScreenLayout } from '@/components/AppShell';
import { Toaster } from '@/components/ui/sonner';

import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Pos from '@/pages/Pos';
import Kds from '@/pages/Kds';
import FloorPlan from '@/pages/FloorPlan';
import Reservations from '@/pages/Reservations';
import Menu from '@/pages/Menu';
import Recipes from '@/pages/Recipes';
import Inventory from '@/pages/Inventory';
import Suppliers from '@/pages/Suppliers';
import Expenses from '@/pages/Expenses';
import Income from '@/pages/Income';
import Invoices from '@/pages/Invoices';
import Reports from '@/pages/Reports';
import Pgc from '@/pages/Pgc';
import Settings from '@/pages/Settings';
import Locations from '@/pages/Locations';
import Users from '@/pages/Users';
import PublicReserve from '@/pages/PublicReserve';

function Shell({ children, fullBleed = false }) {
  return <AppShell fullBleed={fullBleed}>{children}</AppShell>;
}

function Protected({ children, fullBleed = false, allowedRoles }) {
  return (
    <ProtectedRoute allowedRoles={allowedRoles}>
      <Shell fullBleed={fullBleed}>{children}</Shell>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <I18nProvider>
      <BrandingProvider>
        <BrowserRouter>
          <AuthProvider>
            <div className="App">
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/reservar" element={<PublicReserve />} />
                <Route path="/reserve" element={<PublicReserve />} />

                {/* Default redirect */}
                <Route path="/" element={<Navigate to="/dashboard" replace />} />

                {/* Protected app routes */}
                <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
                <Route path="/pos" element={<Protected fullBleed><Pos /></Protected>} />
                <Route path="/floor-plan" element={<Protected fullBleed><FloorPlan /></Protected>} />
                <Route path="/reservations" element={<Protected><Reservations /></Protected>} />
                <Route path="/kds" element={
                  <ProtectedRoute>
                    <FullScreenLayout><Kds /></FullScreenLayout>
                  </ProtectedRoute>
                } />
                <Route path="/menu" element={<Protected><Menu /></Protected>} />
                <Route path="/recipes" element={<Protected><Recipes /></Protected>} />
                <Route path="/inventory" element={<Protected><Inventory /></Protected>} />
                <Route path="/suppliers" element={<Protected><Suppliers /></Protected>} />
                <Route path="/expenses" element={<Protected><Expenses /></Protected>} />
                <Route path="/income" element={<Protected><Income /></Protected>} />
                <Route path="/invoices" element={<Protected><Invoices /></Protected>} />
                <Route path="/reports" element={<Protected><Reports /></Protected>} />
                <Route path="/pgc" element={<Protected><Pgc /></Protected>} />
                <Route path="/locations" element={<Protected><Locations /></Protected>} />
                <Route path="/settings" element={<Protected><Settings /></Protected>} />
                <Route path="/users" element={<Protected allowedRoles={['admin_empresa', 'admin_ferramenta']}><Users /></Protected>} />

                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
            </div>
            <Toaster richColors position="top-right" />
          </AuthProvider>
        </BrowserRouter>
      </BrandingProvider>
    </I18nProvider>
  );
}

export default App;
